export default {
      id: "icon-search-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }